// extracted by mini-css-extract-plugin
export var compactFilters = "_c7-4";
export var detailImage = "_c7-1";
export var dropdownContainer = "_c7-2";
export var imageContainer = "_c7-0";
export var selectedCard = "_c7-3";